import * as React from 'react';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch } from 'react-redux';
import { TDispatch } from '../../types/Thunk';
import { oAuthServiceInit } from '../../actions/AuthActions';
import { AxiosResponse } from 'axios';
import { useState } from 'react';
import Loader from '../Loader';
import microsoftLogo from '../../assets/images/microsoft.svg';
import googleLogo from '../../assets/images/google.svg';
import entraLogo from '../../assets/images/entra.svg';

const useStyles = makeStyles((theme: Theme) => ({
  authButtons: {
    margin: theme.spacing(2, 0, 2),
    display: 'flex',
    gap: '5px',
    width: '100%',
    '& button': {
      width: '49%',
    },
  },
  azureButton: {
    backgroundColor: '#cbf8ff',
    color: 'black',
    '&:hover': {
      backgroundColor: '#a3e8ff',
    },
  },
  google: {
    color: 'white',
    width: '18px !important',
    marginRight: '8px',
    filter: 'invert(1)',
  },
  microsoft: {
    color: 'white',
    width: '18px !important',
    marginRight: '8px',
    filter: 'invert(1)',
  },
  azure: {
    width: '18px !important',
    marginRight: '8px',
  },
}));

interface ISocialButtonsProps {
  googleAllowed: boolean;
  microsoftAllowed: boolean;
  azureAllowed: boolean;
}

const SocialButtons: React.FC<ISocialButtonsProps> = ({
  googleAllowed,
  microsoftAllowed,
  azureAllowed,
}): JSX.Element => {
  const classes = useStyles({});
  const dispatch = useDispatch<TDispatch>();
  const [loading, setLoading] = useState(false);
  const currentUrl = window.location.pathname.replace('/app', '');

  const onlyOneEnabled =
    (googleAllowed && !microsoftAllowed && !azureAllowed) ||
    (!googleAllowed && microsoftAllowed && !azureAllowed) || (!googleAllowed && !microsoftAllowed && azureAllowed);

  const handleLoginService = (service: 'microsoft' | 'google' | 'azure') => {
    setLoading(true);
    dispatch(oAuthServiceInit(service, { fallbackUrl: currentUrl }))
      .then((res: AxiosResponse<any>) => {
        window.location.replace(res.data.gotoUrl);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <Loader visible={loading} />;
  }

  return (
    <div
      className={classes.authButtons}
      style={{ justifyContent: onlyOneEnabled ? 'center' : 'space-between' }}
    >
      {googleAllowed && (
        <Button
          type='button'
          variant='contained'
          color='primary'
          onClick={() => handleLoginService('google')}
        >
          <img src={googleLogo} className={classes.google} alt='' />
          Google
        </Button>
      )}

      {microsoftAllowed && (
        <Button
          type='button'
          variant='contained'
          color='primary'
          onClick={() => handleLoginService('microsoft')}
        >
          <img src={microsoftLogo} className={classes.microsoft} alt='' />
          Microsoft
        </Button>
      )}
      {azureAllowed && (
        <Button
          type='button'
          variant='contained'
          color='primary'
          className={classes.azureButton}
          onClick={() => handleLoginService('azure')}
        >
          <img src={entraLogo} className={classes.azure} alt='' />
          Entra
        </Button>
      )}
    </div>
  );
};

export default SocialButtons;
